export default __webpack_public_path__ + "b8fe39a340a3d76ef0ff469d1d9a0494.png";